import { AfterContentInit, ChangeDetectorRef, ContentChild, Directive, DOCUMENT, HostBinding, inject, OnDestroy, PLATFORM_ID, Renderer2 } from '@angular/core';

import { BreakpointService } from '../../services/breakpoint.service';
import { BottomSwipeSheetDirective } from './bottom-swipe-sheet.directive';
import { OverlaySwipeDirective } from './overlay-swipe.directive';
import { Subscription } from 'rxjs';
import { isPlatformBrowser } from '@angular/common';

@Directive({
  selector: '[appModalSwipe]',
})
export class ModalSwipeDirective implements AfterContentInit, OnDestroy {
  breakPoint = inject(BreakpointService);
  private renderer = inject(Renderer2);
  private changeDetectorRef = inject(ChangeDetectorRef);
  private platformId = inject(PLATFORM_ID);
  private document = inject<Document>(DOCUMENT);

  @HostBinding('class.is-open') toggle: boolean = false;

  @ContentChild(BottomSwipeSheetDirective) bottomSwipeSheet: BottomSwipeSheetDirective;
  @ContentChild(OverlaySwipeDirective) overlaySwipe: OverlaySwipeDirective;

  private swipeOpacitySub: Subscription;

  ngAfterContentInit(): void {
    if(!isPlatformBrowser(this.platformId)) {
      return;
    }
    if(this.breakPoint.isMobile) {
      this.renderer.addClass(this.document.documentElement, 'is-scroll');

      setTimeout(() => {
        this.toggle = !this.toggle;
        this.changeDetectorRef.markForCheck();
      }, 300);
    }

    this.swipeOpacitySub = this.bottomSwipeSheet.swipeOpacity.subscribe((value) => {
      this.overlaySwipe.setOpacity(value);
    });
  }

  hideModal(direction?: 'up' | 'down' | 'left' | 'right'): void {
    this.bottomSwipeSheet.swipeModal(direction);
    this.overlaySwipe.fadeOverlay();
  }

  ngOnDestroy(): void {
    if(!isPlatformBrowser(this.platformId)) {
      return;
    }
    this.renderer.removeClass(this.document.documentElement, 'is-scroll');
    this.swipeOpacitySub?.unsubscribe();
  }
}
